import { capitalize, EventId, ReferenceContactId } from "@sp-crm/core";
import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { Link } from "react-router-dom";
import { hrefForActivityRecord } from "util/activity-record-href";

export interface EventActivityTitleSubject {
    contactId: ReferenceContactId;
    name: string;
}

export interface EventActivityTitleEvent {
    eventId: EventId;
    title: string;
    action: string;
}

interface EventActivityTitleProps {
    subjects: EventActivityTitleSubject[];
    event: EventActivityTitleEvent;
}

const subjectSeparator = (index: number, count: number): string => {
    if (index >= count - 1) {
        return "";
    }
    return index === count - 2 ? " and " : ", ";
};

const SubjectLinks: React.FC<{ subjects: EventActivityTitleSubject[] }> = ({
    subjects,
}) => (
    <>
        {subjects.map((subject, index) => (
            <React.Fragment key={subject.contactId}>
                <Link
                    to={hrefForActivityRecord("referenceContact", subject.contactId)}
                    className={defaultLinkStyle}>
                    {subject.name}
                </Link>
                {subjectSeparator(index, subjects.length)}
            </React.Fragment>
        ))}
    </>
);

export const EventActivityTitle: React.FC<EventActivityTitleProps> = ({
    subjects,
    event,
}) => (
    <span>
        {subjects.length > 0 ? (
            <>
                <SubjectLinks subjects={subjects} /> {event.action}
            </>
        ) : (
            capitalize(event.action)
        )}{" "}
        <Link to={`/events/${event.eventId}`} className={defaultLinkStyle}>
            {event.title}
        </Link>
    </span>
);
